import { render, staticRenderFns } from "./ClockSetting.vue?vue&type=template&id=3b0154ca&scoped=true&"
import script from "./ClockSetting.vue?vue&type=script&lang=ts&"
export * from "./ClockSetting.vue?vue&type=script&lang=ts&"
import style0 from "./ClockSetting.vue?vue&type=style&index=0&id=3b0154ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0154ca",
  null
  
)

export default component.exports